import React from 'react';
import { IIconProps } from '../IIconProps';

export const TemplateIcon = ({
	iconClass = '',
	title = '',
	pointer,
}: IIconProps) => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={`${iconClass} ${pointer ? 'icon--pointer' : ''}`}
		>
			{title && <title>{title}</title>}
			<rect width="24" height="24" fill="none" />
			<path
				d="M2.62127 4.4497L2.62127 7.07096C2.62127 7.20352 2.67396 7.33076 2.76766 7.42452L4.97185 9.6287C5.07677 9.73363 5.22319 9.78715 5.37098 9.77371L8.79395 9.46228L8.88372 10.458L5.46144 10.7688C5.01809 10.8091 4.57952 10.6506 4.26474 10.3358L2.06056 8.13162C1.77932 7.85033 1.62138 7.46874 1.62138 7.07096L1.62138 4.4497C1.62142 3.55885 2.69842 3.11271 3.32838 3.74259L5.65686 6.07107L7.07107 4.65686L4.74259 2.32837C4.11272 1.69842 4.55885 0.621418 5.4497 0.621375L8.07096 0.621375C8.46874 0.621375 8.85033 0.779317 9.13162 1.06055L11.3358 3.26474C11.6506 3.57952 11.8091 4.01809 11.7688 4.46143L11.458 7.88372L10.4623 7.79395L10.7737 4.37097C10.7871 4.22319 10.7336 4.07677 10.6287 3.97185L8.42452 1.76766C8.33076 1.67396 8.20352 1.62127 8.07096 1.62127L5.4497 1.62127L8.48528 4.65686L5.65686 7.48528L2.62127 4.4497Z"
				fill="currentColor"
			/>
			<path
				d="M8.48528 10.3137C8.29002 10.1184 8.29002 9.80186 8.48528 9.6066C8.68055 9.41134 8.99713 9.41134 9.19239 9.6066L11.3137 11.7279L10.6066 12.435L8.48528 10.3137Z"
				fill="currentColor"
			/>
			<path
				d="M10.6066 8.19239C10.4113 7.99713 10.4113 7.68054 10.6066 7.48528C10.8019 7.29002 11.1184 7.29002 11.3137 7.48528L13.435 9.6066L12.7279 10.3137L10.6066 8.19239Z"
				fill="currentColor"
			/>
			<path
				d="M20.0104 21.8388L13.6464 15.4749L14.3536 14.7678L20.7175 21.1317C20.9128 21.327 21.2294 21.327 21.4246 21.1317L22.1317 20.4246C22.327 20.2294 22.327 19.9128 22.1317 19.7175L15.7678 13.3536L16.4749 12.6464L22.8388 19.0104C23.4246 19.5962 23.4246 20.5459 22.8388 21.1317L22.1317 21.8388C21.5459 22.4246 20.5962 22.4246 20.0104 21.8388Z"
				fill="currentColor"
			/>
			<path
				d="M4.53554 21.799L3.82843 22.5061L3.12132 21.799L3.82843 21.0919L4.53554 21.799ZM7.36396 21.799L11.6066 17.5563C12.3877 16.7753 12.3877 15.509 11.6066 14.7279L10.8995 14.0208C10.1184 13.2398 8.85212 13.2398 8.07107 14.0208L3.82843 18.2635C3.04738 19.0445 3.04738 20.3108 3.82843 21.0919L3.12132 21.799L3.01498 21.6871C1.9852 20.5474 1.9852 18.8079 3.01498 17.6682L3.12132 17.5563L7.36396 13.3137C8.49894 12.1787 10.3171 12.1433 11.4947 13.2074L11.6066 13.3137L12.3137 14.0208L12.4201 14.1327C13.4841 15.3103 13.4487 17.1285 12.3137 18.2635L8.07107 22.5061L7.9592 22.6124C6.81952 23.6422 5.07998 23.6422 3.9403 22.6124L3.82843 22.5061L4.53554 21.799C5.31658 22.58 6.58291 22.58 7.36396 21.799Z"
				fill="currentColor"
			/>
			<path
				d="M22.1483 4.76352L19.0989 9.38457L18.9656 9.44327L17.7793 9.96945L12.3393 15.4095L11.6322 14.7024L17.2034 9.13115L17.2883 9.09317L18.4249 8.5877L20.8639 4.89334L20.7341 4.76352L17.039 7.20179L16.5343 8.3391L16.4963 8.42404L10.925 13.9953L10.2179 13.2882L15.658 7.84813L16.1842 6.6618L16.2428 6.52852L20.8639 3.47913L22.1483 4.76352Z"
				fill="currentColor"
			/>
			<defs>
				<clipPath id="clip0_2_15">
					<rect width="24" height="24" fill="none" />
				</clipPath>
			</defs>
		</svg>
	);
};
